export const {
    REACT_APP_OEE_UserPoolID: userPoolId,
    REACT_APP_OEE_UserPoolsWebClientID: userPoolWebClientId,
    REACT_APP_OEE_functionsApiURL: azureFunctionsURL,
    REACT_APP_realtimeInstanceURL: socketsURL,
    REACT_APP_OEE_TokenId: tokenId,
    REACT_APP_PORT: PORT,
} = process.env;
